module.exports = __webpack_public_path__ + "static/img/strona_012.a5f508bf.jpg";